import { StorageSyncOptions } from './interfaces';
import { isPlainObjectAndEmpty } from './util';

const dateMatcher = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;

const reviver = (_: string, value: any) => {
  return dateMatcher.test(String(value)) && !isNaN(Date.parse(value)) ? new Date(value) : value;
};

// restores the resolved state from a storage location
export const rehydrateState = <T>({ prefix, features }: StorageSyncOptions<T>): T | undefined => {
  const rehydratedState = features.reduce((acc, curr) => {
    const { stateKey } = curr;

    try {
      const key = `${prefix}-${stateKey}`;

      const featureState = window.sessionStorage.getItem(key);

      if (featureState) {
        return {
          ...acc,
          ...{
            [stateKey]: JSON.parse(featureState, reviver),
          },
        };
      } else {
        return acc;
      }
    } catch (e) {
      console.error('rehydrateState error:', e);
    }
  }, Object()) as T;

  return !isPlainObjectAndEmpty(rehydratedState) ? rehydratedState : undefined;
};
